import React from 'react'
import { Outlet } from 'react-router-dom';
import NavBar from '../components/navbar/NavBar'
import FooterSidebar from '../components/footer/FooterSidebar';
import './layout.css'

const Layout: React.FC = () => {
  return (
    <div className='app-layout'>
        <NavBar />
        <main className='layout-content'>
          <Outlet />
        </main>
        <FooterSidebar />
    </div>
  )
}

export default Layout